import { login, refresh } from "../api/auth";

export default {
  namespaced: true,
  state: () => ({
    userId: null,
    accessToken: null,
    accessTokenExpiry: null,
    refreshToken: null,
    refreshTokenExpiry: null
  }),
  actions: {
    async login(context, { username, password }) {
      const result = await login(username, password);
      context.commit("setAuthTokens", result);
    },
    async refresh(context) {
      const authTokens = context.getters.getAuthTokens;
      const refreshToken = authTokens.refreshToken;

      const result = await refresh(refreshToken);
      context.commit("setAuthTokens", result);
    }
  },
  getters: {
    getAuthTokens: state => {
      return {
        userId: state.userId,
        accessToken: state.accessToken,
        accessTokenExpiry: state.accessTokenExpiry,
        refreshToken: state.refreshToken,
        refreshTokenExpiry: state.refreshTokenExpiry
      };
    },
    getAccessToken: state => state.accessToken
  },
  mutations: {
    setAuthTokens(state, authTokens) {
      state.userId = authTokens.userId;
      state.accessToken = authTokens.accessToken;
      state.accessTokenExpiry = authTokens.accessTokenExpiry;
      state.refreshToken = authTokens.refreshToken;
      state.refreshTokenExpiry = authTokens.refreshTokenExpiry;
    }
  }
};
